var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDisableCamera(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "23px",
    viewBox: "0 0 25 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icDisableCamera") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main-screens-Stage-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Voice-call---receiving",
    transform: "translate(-283.000000, -669.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(30.000000, 579.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(25.000000, 66.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(216.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6855811,15.2802757 L33.979293,35.5739876 C34.354554,35.9492485 34.354554,36.5576668 33.979293,36.9329277 C33.604032,37.3081887 32.9956138,37.3081887 32.6203528,36.9329277 L27.516,31.828 L19.5348935,31.8282095 C17.8074884,31.8282095 16.4065546,30.3071268 16.4065546,28.4315735 L16.4065546,20.8710296 L16.41,20.723 L12.3266409,16.6392158 C11.95138,16.2639549 11.95138,15.6555367 12.3266409,15.2802757 C12.7019019,14.9050147 13.3103201,14.9050147 13.6855811,15.2802757 Z M28.7008849,17.4743935 C30.4282899,17.4743935 31.8292237,18.9954762 31.8292237,20.8710296 L31.8292237,21.4947184 L35.3253593,19.3050772 C35.8832533,18.9461196 36.5857864,19.3903296 36.5857864,20.0902968 L36.5857864,29.2033323 C36.5857864,29.9077865 35.8832533,30.3475096 35.3212268,29.9975259 L31.8250912,27.8078847 L31.8250912,28.4315735 C31.8250912,29.2054497 31.5865838,29.9189776 31.1850467,30.4902067 L18.3987764,17.705428 C18.7509668,17.5562606 19.1341445,17.4743935 19.5348935,17.4743935 L28.7008849,17.4743935 Z",
    id: "icDisableCamera"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDisableCamera);
export default __webpack_public_path__ + "static/media/icDisableCamera.5faf9f3ee3640f9521e00dfd3c8bffaf.svg";
export { ForwardRef as ReactComponent };